// Копирайт статистики — spec/08_copy.md, раздел «Статистика и профиль» (часть stats.*).
// Голос — вариант A «своя в чате» (docs/copy-variants.md).
import { FORECAST_FORMS, pluralizeWithCount } from '~/shared/utils'

import type { StatsCopy } from './types'

export const stats: StatsCopy = {
  month: 'Твой месяц',
  month_note: 'В этом месяце ты чаще растёшь, чем убываешь. Горжусь тобой.',
  hitrate: ({ n }) => `Попадаю в ${n}%. Смотри, что предсказывала`,
  forecasts_count: ({ n }) => pluralizeWithCount(n, FORECAST_FORMS),
  hitrate_new: 'Ещё коплю статистику',
  archive_title: 'Что я предсказала',
  hit: 'сбылось',
  miss: 'мимо',
  // Было «Три кита твоего неба»: метафора не читается, а «киты» тянут не туда (правка
  // редактора). Заголовок просто называет, что под ним лежит, — Солнце, Луна и асцендент.
  whales: 'Основа твоей карты',
}
